import styles from "./notificationBottom.module.scss";
import React from 'react';
import { Cookie, enablePermission, jenkinMessageClose } from "../../../../base/utils";
import { useSelector } from "react-redux";
import { initialStateModel } from "../../../../models/model";
import { useHistory } from "react-router-dom";
import updateavailable from "../../../../styles/images/updateavailable.svg"

export default function NotificationBottom() {
  let {jenkinMessage}: any = useSelector((state: initialStateModel) => state.contactReducer);
  const history = useHistory();
  //let startingScreenLoader = store.getState().startingScreenReducer;
  const BrowserenablePermission = async ()=>{
    if(navigator.userAgent.indexOf("Edg") !== -1 || navigator.userAgent.indexOf("Chrome") !== -1)
    {
      enablePermission('leftsidebar');
    }  else {
      if(navigator.userAgent.indexOf("Safari") !== -1 || navigator.userAgent.indexOf("Firefox") !== -1)
        {
         //window.location.reload();
        enablePermission('leftsidebar');
        }
    }
    
  }
  const closeNotification=()=>{
    
  }
    
  const handleCancel = () => {
    jenkinMessageClose();
  };

  const handleOk = () => {
    Cookie.deleteKey('userinfo');
    history.push('/home');
   // window.location.reload();
    jenkinMessageClose();
  };
  return (
    <>
    {jenkinMessage &&  <div className={styles.enablenote}>
        <span onClick={handleCancel}>
          <img src={updateavailable} alt="" />
        </span>
        <p>
          <h5>Update Available</h5>
          A new version of the app is available. <br /><a onClick={handleOk}>Update Version.</a></p>
      </div>}
      {!jenkinMessage &&  <div className={styles.enablenote}>
        <span className="icon_outlinenotification"  onClick={closeNotification}></span>
        <p>Enable notifications, Worktual is better if you do . <a onClick={BrowserenablePermission}>Enable permission.</a></p>
      </div>}
    </>
  );
};

